import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { League } from '@mtgame/core';
import { LoaderService, ToastService } from '@mtgame/ui';
import { LeagueRootService } from '@core/services/league-root.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { environment } from '@env/environment';
import { REQUEST, RESPONSE } from '@nguniversal/express-engine/tokens';
import { Request, Response } from 'express';

@Injectable({providedIn: 'root'})
export class RootResolver implements Resolve<League> {
  constructor(
    private loaderService: LoaderService,
    private toastService: ToastService,
    private leagueRootService: LeagueRootService,
    private router: Router,
    @Inject(DOCUMENT) private document,
    @Optional() @Inject(REQUEST) protected request: Request,
    @Optional() @Inject(RESPONSE) protected response: Response,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {
  }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<League> {
    this.loaderService.show();
    try {
      return await this.leagueRootService.initialize(
        environment.testDomain ||
        (this.request && this.request.hostname) ||
        this.document.location.hostname
      );
    } catch (e) {
      // On the server, the league API failing (not an unknown domain: that stays 200, the ansible deploy check opens /
      // by IP) answers 500, so nginx does not cache the empty page and serves the last good one instead
      if (!isPlatformBrowser(this.platformId) && this.response && e?.status !== 404) {
        this.response.status(500);
      }
      if (e.status === 404) {
        this.router.navigate(['/invalid_domain'], {skipLocationChange: true, replaceUrl: false});
      } else {
        this.toastService.danger('Произошла ошибка');
      }
    } finally {
      this.loaderService.hide();
    }
  }
}
